import { Container } from "aurelia-dependency-injection";
import { AuthService } from "../../authentication/auth-service";

export class ContainerHelper {

    public static get AuthService(): AuthService {
        return Container.instance.get(AuthService);
    }

    public static get Events(): Backbone.Events {
        return Container.instance.get(Backbone.Events);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/shared/helpers/container-helper.ts